var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 2.75C14.5437 2.75 17.4166 5.62284 17.4166 9.16667C17.4166 12.7105 14.5437 15.5833 10.9999 15.5833C7.45606 15.5833 4.58322 12.7105 4.58322 9.16667C4.58322 5.62284 7.45606 2.75 10.9999 2.75ZM11.9166 18.2881V19.25H13.7499V21.0833H8.24989V19.25H10.0832V18.2879C7.98696 18.0792 6.0474 17.1593 4.55835 15.6885L5.8467 14.3842C7.21093 15.7317 9.04354 16.5 10.9999 16.5C15.05 16.5 18.3332 13.2168 18.3332 9.16667C18.3332 7.2414 17.5893 5.43559 16.2797 4.07731L17.5995 2.8048C19.2353 4.50144 20.1666 6.76193 20.1666 9.16667C20.1666 13.9199 16.5488 17.8282 11.9166 18.2881ZM6.41656 9.16667C6.41656 6.63536 8.46858 4.58333 10.9999 4.58333C13.5312 4.58333 15.5832 6.63536 15.5832 9.16667C15.5832 11.698 13.5312 13.75 10.9999 13.75C8.46858 13.75 6.41656 11.698 6.41656 9.16667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.3253295575b47ed5f95b5315e8bc6139.svg";
export { ForwardRef as ReactComponent };